import React from "react";
import { useNavigate } from "react-router-dom";
import PortfolioDetail from "../../components/PortfolioDetail";
import "./style.css";

export default function PortfolioDetailPage() {
  const navigate = useNavigate();

  return (
    <div className="portfolio-detail-page">
      <header className="feed_header">
        <button className="feed_back_btn" onClick={() => navigate(-1)}>
          <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
          </svg>
        </button>
        <div className="feed_logo">
          <svg viewBox="0 0 24 24" fill="currentColor" width="28" height="28">
            <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
          </svg>
          <span>Projeto</span>
        </div>
        <div className="feed_nav_icons"></div>
        <button className="feed_create_btn" onClick={() => navigate("/portfolio")}>
          <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
          </svg>
        </button>
      </header>

      <div className="portfolio-detail-container">
        <PortfolioDetail />
      </div>
    </div>
  );
}
